import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import colorLogo from "../../Assets/Images/colorLogo.png";
import whiteLogo from "../../Assets/Images/whiteLogo.png";
import OpenSidebar from "../../Assets/Images/OpenSidebar.svg";
import CloseSidebar from "../../Assets/Images/CloseSidebar.svg";
import Dashboard from "../../Assets/Images/Dashboard.svg";
import Clients from "../../Assets/Images/Clients.svg";
import Tokens from "../../Assets/Images/Tokens.svg";
import LogoutIcon from "../../Assets/Images/logout.svg";
import SupportIcon from '../../Assets/Images/Support.svg'
import FAQDisabled from '../../Assets/Images/faqDisabled.svg'
import { TokenContext } from "../../Context/TokenContext";


const Sidebar = () => {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const { setSelectedToken } = useContext(TokenContext)
  
  const toggleSidebar = () => setIsOpen(!isOpen);
  const isActive = (path) => {
    if (path === "/clients") {
      if(location.pathname === "/add-client"){
        return true
      }
      if(location.pathname.includes("/added-client")){
        return true
      }
      return location.pathname.startsWith("/clients") || location.pathname.startsWith("/client/");
      
    }
   
    return location.pathname === path;
  };

  let name = authCtx?.userName;
  const firstName = name !== "null null" && name ? name.split(" ")[0].charAt(0).toUpperCase() + name.split(" ")[0].slice(1).toLowerCase() : "";

  const handleLogout = () => {
    setSelectedToken(0)

    authCtx.logout();
    navigate("/login");
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className={`sidebar-header ${isOpen ? "open" : "closed"}`}>
        {isOpen && (
        <div className="logo">
            <img src={whiteLogo} alt="Logo" style={{ width: "40px", height: "46px" , objectFit: "contain" }} />
        </div>
        )}
        <button onClick={toggleSidebar} className="toggle-btn">
          {isOpen ? (
            <img src={OpenSidebar} alt="Open Sidebar" />
          ) : (
            <img src={CloseSidebar} className="closesidebar" alt="Close Sidebar" />
          )}
        </button>
      </div>
      {isOpen && (
        <div className="welcome">
          <div>Welcome,</div>
          <div
            className="username"
            style={{
              fontSize:
                firstName.length > 9
                  ? "clamp(14px, 4vw, 22px)"
                  : "30px",
            }}
          >
            {firstName}
          </div>
        </div>
      )}
      <nav>
        <ul>
          <li className={isActive("/dashboard") ? "active" : ""} onClick={() => navigate("/dashboard")}>
            <img src={Dashboard} alt="Dashboard" />
            {isOpen && <div className="menutext">Dashboard</div>}
          </li>
          <li className={isActive("/clients") ? "active" : ""} onClick={() => {
            if (location.pathname === "/clients") {
              window.location.reload();
            } else {
              navigate("/clients");
            }
          }}>
            <img src={Clients} alt="Clients" />
            {isOpen && <div className="menutext">Clients</div>}
          </li>
          <li className={ isActive("/tokens") || isActive("/token-checkout") || isActive("/token-payment-successful" ) ? "active" : "" } onClick={() => navigate("/tokens")}>
            <img src={Tokens} alt="Tokens" />
            {isOpen && <div className="menutext">Tokens</div>}
          </li>
          <li className={isActive("/support") ? "active" : ""}
            onClick={() => navigate("/support")}
          >
            <img src={SupportIcon} alt="Support" />
              {isOpen && <div className="menutext">Support</div>}
          </li>
            <li className={isActive("/faq") ? "active" : ""}
            // onClick={() => navigate("/faq")}
          >
            <img src={FAQDisabled} alt="faq" />
              {isOpen && <div className="menutext" style={{ color: "#A9A9A9" }}>FAQ</div>}
          </li>

        </ul>
      </nav>
      <div className={`logout-section ${isOpen ? "open" : "closed"}`} onClick={handleLogout}>
        <img src={LogoutIcon} alt="Logout" className="logout-icon" />
        {isOpen && <div className="menutext">Log Out</div>}
      </div>
    </div>
  );
};

export default Sidebar;
